module.exports = __webpack_public_path__ + "img/how-step-3.02b0b9a2.png";